export default __webpack_public_path__ + "static/media/hong-kong.aafc63bd.png";